export const policyEngineActions = {
    GET_POLICIES_ACTIONS:'GET_POLICIES_ACTIONS',
    GET_POLICIES_ENUMS: 'GET_POLICIES_ENUMS',
    DELETE_POLICY_RULE: 'DELETE_POLICY_RULE',
    ADD_POLICY_RULE: 'ADD_POLICY_RULE',
    EDIT_POLICY_RULE: 'EDIT_POLICY_RULE',
    DUPLICATE_POLICY_RULE: 'DUPLICATE_POLICY_RULE',
    GET_POLICIES: 'GET_POLICIES',
    GET_ALL_CATEGORIES_WITH_RULE: 'GET_ALL_CATEGORIES_WITH_RULE',
    GET_POLICIES_RULES: 'GET_POLICIES_RULES',
    GET_POLICIES_RULE_DETAILS: 'GET_POLICIES_RULE_DETAILS',
    GET_POLICIE_DETAILS: 'GET_POLICIE_DETAILS',
    SET_POLICY_RULE: 'SET_POLICY_RULE',
    DELETE_POLICY: 'DELETE_POLICY',
    SAVE_POLICY: 'SAVE_POLICY',
    ADD_POLICY: 'ADD_POLICY',
    DUPLICATE_POLICY:'DUPLICATE_POLICY',
    GET_SCOPES: 'GET_SCOPES',
    GET_SCOPE_DETAILS: 'GET_SCOPE_DETAILS',
    SAVE_ENFORCEMENT: 'SAVE_ENFORCEMENT',
    CLEAR_PREVIOUS_STATE: 'CLEAR_PREVIOUS_STATE',
    DELETE_RULE: 'DELETE_RULE'
};

const initState = {
    policies: [],
    categoriesWithRule: [],
    policies_rules: [],
    policies_rule_data: null,
    policies_meta_data: null,
    scopes: []
};

export const policyEngineReducer = (state = initState, action: any) => {
    switch (action.type) {
        case policyEngineActions.GET_POLICIES_ACTIONS:
            return Object.assign({}, state, action.payload);
            
        case policyEngineActions.GET_POLICIES_ENUMS:
            return Object.assign({}, state, action.payload);

        case policyEngineActions.GET_POLICIES_RULE_DETAILS:
            return Object.assign({}, state, action.payload);

        case policyEngineActions.GET_POLICIES_RULES:
            return Object.assign({}, state, action.payload);

        case policyEngineActions.GET_POLICIES:
        case policyEngineActions.CLEAR_PREVIOUS_STATE:
        case policyEngineActions.GET_ALL_CATEGORIES_WITH_RULE:
            return Object.assign({}, state, action.payload);

        case policyEngineActions.GET_SCOPES:
        case policyEngineActions.GET_SCOPE_DETAILS:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/policyEngineReducer.ts